"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StunAbilityHandler = exports.StunActorAbilityFactory = exports.StunAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
class StunAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Stun;
        this.__typeName = "Stun";
    }
}
exports.StunAbilityArgs = StunAbilityArgs;
let StunActorAbilityFactory = class StunActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Stun", "Self", 0);
    }
};
StunActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Stun")
], StunActorAbilityFactory);
exports.StunActorAbilityFactory = StunActorAbilityFactory;
let StunAbilityHandler = class StunAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        throw new Error("Method not implemented.");
    }
};
StunAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Stun)
], StunAbilityHandler);
exports.StunAbilityHandler = StunAbilityHandler;
